import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import { SimulationAgentData } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/helpers/types';
import StyChip from 'routes/HumanResourcesModule/components/ui/StyChip';
import { MANTY_COLORS } from 'business/constants';
import { HrSimulation } from 'routes/HumanResourcesModule/Simulation/helpers/types';
import ViewIcon from '@mui/icons-material/RemoveRedEye';
import AgentPayComponentResumeHypothesisModal from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/components/PayComponent/AgentPayComponentResumeHypothesisModal';
import { PayComponent } from 'routes/HumanResourcesModule/PayState/helpers/constants';
import {
    AgentPayComponentHypothesis,
    DetailedAgentPayComponentHypothesis,
} from './helpers/types';

type Props = {
    hypothesis:
        | AgentPayComponentHypothesis
        | DetailedAgentPayComponentHypothesis;
    data: SimulationAgentData;
    hrSimulation: HrSimulation;
};

/**
 * Generate a chip component for displaying an agent's pay component hypothesis.
 * Is used in the resume view.
 * The hypothesis cannot be edited
 *
 * @param {AgentPayComponentHypothesis | DetailedAgentPayComponentHypothesis} props.hypothesis - The hypothesis data for the agent
 * @param {SimulationAgentData} props.data - The data related to the hypothesis
 * @param {HrSimulation} props.hrSimulation - The HR simulation data
 * @return {React.ReactElement} The chip component for the agent's pay component hypothesis
 */
const AgentPayComponentHypothesisChip = ({
    hypothesis,
    data,
    hrSimulation,
}: Props): React.ReactElement => {
    const { t } = useTranslation();
    const [showUpdateModal, setShowUpdateModal] = useState<boolean>(false);

    // In case the value is defined, we already have an hypothesis for this agent
    // we display it with the possibility to modify it

    const chipColor = MANTY_COLORS.orange;
    const chipIcon = <ViewIcon />;
    const isIfseHypothesis =
        hypothesis.payComponent === PayComponent.IFSE_AND_MONTHLY_PRIMES;
    return (
        <>
            <StyChip
                label={
                    isIfseHypothesis
                        ? PayComponent.IFSE_AND_MONTHLY_PRIMES
                        : t(
                              'humanResources.simulation.agentPayComponentHypothesisType.simple_prime',
                          )
                }
                onClick={() => setShowUpdateModal(true)}
                icon={chipIcon}
                styledColor={chipColor}
            />

            {showUpdateModal && data && (
                <AgentPayComponentResumeHypothesisModal
                    open={showUpdateModal}
                    onClose={() => setShowUpdateModal(false)}
                    agentData={data}
                    hrSimulation={hrSimulation}
                    hypothesis={hypothesis}
                />
            )}
        </>
    );
};

export default AgentPayComponentHypothesisChip;
